import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "student-compare-container" }
const _hoisted_2 = { class: "filter-section" }
const _hoisted_3 = { class: "filter-item" }
const _hoisted_4 = { class: "filter-actions" }
const _hoisted_5 = { class: "class-selector-container" }
const _hoisted_6 = { class: "class-selector-item" }
const _hoisted_7 = { class: "student-selector-container" }
const _hoisted_8 = { class: "student-selector-item" }
const _hoisted_9 = { class: "student-selector-item" }
const _hoisted_10 = { class: "compare-button-container" }
const _hoisted_11 = { class: "display-option" }
const _hoisted_12 = {
  key: 1,
  class: "comparison-results"
}
const _hoisted_13 = { class: "summary-cards" }
const _hoisted_14 = { class: "summary-card col-1-card" }
const _hoisted_15 = { class: "summary-item" }
const _hoisted_16 = { class: "student-name" }
const _hoisted_17 = { class: "score" }
const _hoisted_18 = { class: "summary-item" }
const _hoisted_19 = { class: "student-name" }
const _hoisted_20 = { class: "score" }
const _hoisted_21 = { class: "summary-card col-2-card" }
const _hoisted_22 = { class: "summary-item" }
const _hoisted_23 = { class: "student-name" }
const _hoisted_24 = { class: "rank" }
const _hoisted_25 = { class: "summary-item" }
const _hoisted_26 = { class: "student-name" }
const _hoisted_27 = { class: "rank" }
const _hoisted_28 = { class: "summary-card col-3-card" }
const _hoisted_29 = { class: "summary-item" }
const _hoisted_30 = { class: "student-name" }
const _hoisted_31 = { class: "rank" }
const _hoisted_32 = { class: "summary-item" }
const _hoisted_33 = { class: "student-name" }
const _hoisted_34 = { class: "rank" }
const _hoisted_35 = { class: "summary-card col-1-card" }
const _hoisted_36 = { class: "summary-item" }
const _hoisted_37 = { class: "student-name" }
const _hoisted_38 = { class: "score" }
const _hoisted_39 = { class: "summary-item" }
const _hoisted_40 = { class: "student-name" }
const _hoisted_41 = { class: "score" }
const _hoisted_42 = { class: "summary-card col-2-card" }
const _hoisted_43 = { class: "summary-item" }
const _hoisted_44 = { class: "student-name" }
const _hoisted_45 = { class: "rank" }
const _hoisted_46 = { class: "summary-item" }
const _hoisted_47 = { class: "student-name" }
const _hoisted_48 = { class: "rank" }
const _hoisted_49 = { class: "summary-card col-3-card" }
const _hoisted_50 = { class: "summary-item" }
const _hoisted_51 = { class: "student-name" }
const _hoisted_52 = { class: "rank" }
const _hoisted_53 = { class: "summary-item" }
const _hoisted_54 = { class: "student-name" }
const _hoisted_55 = { class: "rank" }
const _hoisted_56 = {
  key: 2,
  class: "no-data"
}

import { ref, onMounted, computed } from 'vue';
import { message } from 'ant-design-vue';
import { getClassesApi } from '@/servers/api/classes';
import { getClassExam } from '@/servers/api/grade';
import { getCompareWithStudent } from '@/servers/api/analysis';
import { getStudentApi } from '@/servers/api/student';
import { useUserStore } from '@/store';

// 类型定义 
interface ClassInfo {
  id: number;
  name: string;
  header: string | null;
  school_id: string | null;
  subject_selection: string;
}

interface ExamInfo {
  id: number;
  name: string;
}

interface StudentInfo {
  id: string;
  name: string;
  class_id: number;
  uid: string;
}

interface SubjectScores {
  '语文': number;
  '数学': number;
  '英语': number;
  '物理': number;
  '化学': number;
  '生物': number;
  '历史': number;
  '政治': number;
  '地理': number;
}

interface StudentResult {
  id: number;
  student_id: string;
  school_id: string;
  exam_id: number;
  class_id: string;
  '总分': number;
  '总分班次': number; // 班级总分排名
  '总分段次': number; // 年级总分排名
  '语文'?: number;
  '语文班次'?: number; // 语文班级排名
  '语文段次'?: number; // 语文年级排名
  '数学'?: number;
  '数学班次'?: number;
  '数学段次'?: number;
  '英语'?: number;
  '英语班次'?: number;
  '英语段次'?: number;
  '物理'?: number;
  '物理班次'?: number;
  '物理段次'?: number;
  '化学'?: number;
  '化学班次'?: number;
  '化学段次'?: number;
  '历史'?: number;
  '历史班次'?: number;
  '历史段次'?: number;
  '政治'?: number;
  '政治班次'?: number;
  '政治段次'?: number;
  '生物'?: number;
  '生物班次'?: number;
  '生物段次'?: number;
  '地理'?: number;
  '地理班次'?: number;
  '地理段次'?: number;
}

interface ComparisonResult {
  valid: boolean;
  current_student?: StudentResult;
  compare_student?: StudentResult;
  total_score?: {
    current: number;
    compare: number;
  };
  class_rank?: {
    current: number;
    compare: number;
  };
  grade_rank?: {
    current: number;
    compare: number;
  };
  subject_score?: {
    current: SubjectScores;
    compare: SubjectScores;
  };
}

// 科目信息类型（含分数、排名）
interface SubjectInfo {
  name: string;
  enKey: string;
  s1Score: number;
  s2Score: number;
  scoreDiff: number;
  s1ClassRank: string | number;
  s2ClassRank: string | number;
  classRankDiff: number | string;
  s1GradeRank: string | number;
  s2GradeRank: string | number;
  gradeRankDiff: number | string;
}

// 状态管理

export default /*@__PURE__*/_defineComponent({
  __name: 'StudentCompare',
  setup(__props) {

const userStore = useUserStore();
const loading = ref(false);
const hasSearched = ref(false);
const classList = ref<ClassInfo[]>([]);
const examList = ref<ExamInfo[]>([]);
const studentList = ref<StudentInfo[]>([]);
const filteredStudentList1 = ref<StudentInfo[]>([]);
const filteredStudentList2 = ref<StudentInfo[]>([]);
const selectedClassId = ref<number>();
const selectedStudent1 = ref<string>();
const selectedStudent2 = ref<string>();
const selectedExamId = ref<number>(0);
const displayMode = ref<'table' | 'chart'>('table');
const comparisonData = ref<ComparisonResult>({ valid: false });
const searchKeyword1 = ref('');
const searchKeyword2 = ref('');

// 科目名称映射（中文科目名）
const subjectMap = {
  '语文': '语文',
  '数学': '数学',
  '英语': '英语',
  '物理': '物理',
  '化学': '化学',
  '生物': '生物',
  '历史': '历史',
  '政治': '政治',
  '地理': '地理'
};

// 计算总分/总排名差值
const totalScoreDiff = computed(() => {
  const total = comparisonData.value.total_score;
  return (total?.current || 0) - (total?.compare || 0);
});
const rankDiff = computed(() => {
  const rank = comparisonData.value.class_rank;
  return (rank?.current || 0) - (rank?.compare || 0);
});
const gradeRankDiff = computed(() => {
  const rank = comparisonData.value.grade_rank;
  return (rank?.current || 0) - (rank?.compare || 0);
});

// 格式化单科数据（拆分为“分数+班级排名+年级排名”）
const subjectList = computed<SubjectInfo[]>(() => {
  const subjectScore = comparisonData.value.subject_score;
  if (!subjectScore || !comparisonData.value.current_student || !comparisonData.value.compare_student) {
    return [];
  }
  const current = comparisonData.value.current_student;
  const compare = comparisonData.value.compare_student;

  return Object.entries(subjectMap).map(([enKey, name]) => {
    // 分数数据
    const s1Score = subjectScore.current[enKey as keyof SubjectScores] || 0;
    const s2Score = subjectScore.compare[enKey as keyof SubjectScores] || 0;
    const scoreDiff = s1Score - s2Score;

    // 班级排名数据（扁平中文键：`${科目}班次`）
    const s1ClassRankKey = `${enKey}班次` as keyof StudentResult;
    const s2ClassRankKey = `${enKey}班次` as keyof StudentResult;
    const s1ClassRank = current[s1ClassRankKey] || '-';
    const s2ClassRank = compare[s2ClassRankKey] || '-';
    const classRankDiff = (typeof s1ClassRank === 'number' && typeof s2ClassRank === 'number')
      ? s1ClassRank - s2ClassRank
      : '-';

    // 年级排名数据（扁平中文键：`${科目}段次`）
    const s1GradeRankKey = `${enKey}段次` as keyof StudentResult;
    const s2GradeRankKey = `${enKey}段次` as keyof StudentResult;
    const s1GradeRank = current[s1GradeRankKey] || '-';
    const s2GradeRank = compare[s2GradeRankKey] || '-';
    const gradeRankDiff = (typeof s1GradeRank === 'number' && typeof s2GradeRank === 'number')
      ? s1GradeRank - s2GradeRank
      : '-';

    return {
      name,
      enKey,
      s1Score,
      s2Score,
      scoreDiff,
      s1ClassRank,
      s2ClassRank,
      classRankDiff,
      s1GradeRank,
      s2GradeRank,
      gradeRankDiff
    };
  }).filter(item => item.s1Score > 0 || item.s2Score > 0);
});

// 工具函数 
const getStudentName = (studentId: string | undefined) => {
  if (!studentId) return '';
  const student = studentList.value.find(s => s.id === studentId);
  return student ? student.name : '未知学生';
};

// 分数差值样式（正数：学生1更高/绿色；负数：学生2更高/红色；零：默认）
const getScoreDiffClass = (diff: number) => {
  if (diff > 0) return 'positive'; // 学生1更高→ 绿色
  if (diff < 0) return 'negative'; // 学生1更低→ 红色
  return 'zero';
};

// 排名差值样式（排名越小越优：负数→学生1更优/绿色；正数→学生2更优/红色；零→默认）
const getRankDiffClass = (diff: number | string) => {
  if (typeof diff === 'string') return 'zero';
  if (diff > 0) return 'negative'; // 学生1排名更差 → 红色
  if (diff < 0) return 'positive'; // 学生1排名更优 → 绿色
  return 'zero';
};

// 格式化分数
const formatScore = (score: number) => {
  return score.toFixed(2);
};

// 接口请求
const handleExamChange = (examId: number) => {
  selectedExamId.value = examId;
};

const fetchStudentListAndExams = async () => {
  if (!selectedClassId.value) return;
  try {
    loading.value = true;
    const [studentRes, examRes] = await Promise.all([
      getStudentApi({ class_id: selectedClassId.value }),
      getClassExam({ class_id: selectedClassId.value })
    ]);
    if (studentRes.code === 200 && studentRes.data) {
      studentList.value = studentRes.data.map((item: any) => ({
        id: item.uid,        
        name: item.name,
        class_id: item.class_id,
        uid: item.uid        
      }));
      filteredStudentList1.value = [...studentList.value];
      filteredStudentList2.value = [...studentList.value];
      selectedStudent1.value = undefined;
      selectedStudent2.value = undefined;
    } else {
      message.warning(studentRes.msg || '获取学生列表失败');
    }
    if (examRes.code === 200 && examRes.data.length > 0) {
      // 直接使用返回的考试对象数组（包含id和name）
      examList.value = examRes.data.map((exam: any) => ({
        id: exam.id,
        name: exam.name
      }));
      // 默认选择最新的考试（最后一个）
      selectedExamId.value = examList.value[examList.value.length - 1].id;
    } else {
      message.warning(examRes.msg || '获取考试列表失败');
    }
  } catch (err) {
    message.error('获取学生或考试列表失败');
  } finally {
    loading.value = false;
  }
};

const handleStudent1Search = (value: string) => {
  searchKeyword1.value = value;
  filteredStudentList1.value = !value 
    ? [...studentList.value]
    : studentList.value.filter(student => 
        student.name.toLowerCase().includes(value.toLowerCase()) ||
        student.uid.includes(value)
      );
};

const handleStudent2Search = (value: string) => {
  searchKeyword2.value = value;
  filteredStudentList2.value = !value 
    ? [...studentList.value]
    : studentList.value.filter(student => 
        student.name.toLowerCase().includes(value.toLowerCase()) ||
        student.uid.includes(value)
      );
};

const handleStudent1Change = (studentId: string) => {
  selectedStudent1.value = studentId;
};

const handleStudent2Change = (studentId: string) => {
  selectedStudent2.value = studentId;
};

const fetchComparisonData = async () => {
  if (selectedStudent1.value === selectedStudent2.value) {
    message.warning('请选择不同的学生进行对比');
    return;
  }
  if (!selectedStudent1.value || !selectedStudent2.value || !selectedExamId.value) {
    message.warning('请选择完整的对比条件');
    return;
  }
  try {
    loading.value = true;
    hasSearched.value = true;
    const res = await getCompareWithStudent({
      student_id: selectedStudent1.value,  
      compare_student_id: selectedStudent2.value,  
      selected_exam_id: selectedExamId.value.toString()
    });
    if (res.code === 200 && res.data) {
      const { current_student, compare_student } = res.data;
      comparisonData.value = {
        valid: true,
        current_student,
        compare_student,
        total_score: {
          current: current_student['总分'] || 0,
          compare: compare_student['总分'] || 0
        },
        class_rank: {
          current: current_student['总分班次'] || 0,
          compare: compare_student['总分班次'] || 0
        },
        grade_rank: {
          current: current_student['总分段次'] || 0,
          compare: compare_student['总分段次'] || 0
        },
        subject_score: {
          current: {
            '语文': current_student['语文'] || 0,
            '数学': current_student['数学'] || 0,
            '英语': current_student['英语'] || 0,
            '物理': current_student['物理'] || 0,
            '化学': current_student['化学'] || 0,
            '生物': current_student['生物'] || 0,
            '历史': current_student['历史'] || 0,
            '政治': current_student['政治'] || 0,
            '地理': current_student['地理'] || 0,
          },
          compare: {
            '语文': compare_student['语文'] || 0,
            '数学': compare_student['数学'] || 0,
            '英语': compare_student['英语'] || 0,
            '物理': compare_student['物理'] || 0,
            '化学': compare_student['化学'] || 0,
            '生物': compare_student['生物'] || 0,
            '历史': compare_student['历史'] || 0,
            '政治': compare_student['政治'] || 0,
            '地理': compare_student['地理'] || 0,
          }
        }
      };
    } else {
      message.error(res?.msg || '获取对比数据失败');
      comparisonData.value = { valid: false };
    }
  } catch (err) {
    message.error('获取对比数据失败');
    comparisonData.value = { valid: false };
  } finally {
    loading.value = false;
  }
};

const resetFilters = () => {
  if (examList.value.length > 0) {
    selectedExamId.value = examList.value[examList.value.length - 1].id;
  }
  if (classList.value.length > 0) {
    selectedClassId.value = classList.value[0].id;
    fetchStudentListAndExams();
  }
  selectedStudent1.value = undefined;
  selectedStudent2.value = undefined;
  comparisonData.value = { valid: false };
  hasSearched.value = false;
};

const isCompareBtnDisabled = computed(() => {
  return (
    loading.value || 
    !selectedClassId.value || 
    !selectedStudent1.value || 
    !selectedStudent2.value || 
    !selectedExamId.value || 
    selectedStudent1.value === selectedStudent2.value
  );
});

const init = async () => {
  try {
    const userInfo = userStore.getUserInfo();
    const teacherId = String(userInfo?.role || userInfo?.teacher?.uid || '').trim();
    if (!teacherId) {
      message.error('未获取到教师信息');
      return;
    }
    loading.value = true;

    let classes: ClassInfo[] = [];
    const classRes = await getClassesApi({ header: teacherId });
    if (classRes.code === 200 && classRes.data.length > 0) {
      classes = classRes.data;
    }

    // 兼容非班主任教师：回退全班级（可按学校过滤）
    if (classes.length === 0) {
      const allClassRes = await getClassesApi({});
      if (allClassRes.code === 200 && Array.isArray(allClassRes.data)) {
        classes = allClassRes.data;
      }
      if (classes.length > 0) {
        message.warning('未找到班主任绑定班级，已切换为全班级');
      }
    }

    if (classes.length > 0) {
      classList.value = classes;
      selectedClassId.value = classList.value[0].id;
      await fetchStudentListAndExams();
    } else {
      message.warning(classRes.msg || '未找到可用班级');
    }
  } catch (err) {
    message.error('初始化失败');
  } finally {
    loading.value = false;
  }
};

onMounted(init);

// 学号脱敏处理，只显示后四位
const maskStudentId = (uid: string) => {
  if (!uid) return '';
  const idStr = String(uid);
  if (idStr.length <= 4) return idStr;
  return '**' + idStr.slice(-4);
};

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "header" }, [
      _createElementVNode("h2", null, "学生对比"),
      _createElementVNode("p", null, "选择考试和学生进行对比分析")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_row, { gutter: [16, 16] }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            span: 24,
            md: 8
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "filter-label" }, "考试：", -1)),
                _createVNode(_component_a_select, {
                  value: selectedExamId.value,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((selectedExamId).value = $event)),
                  placeholder: "选择考试",
                  style: {"width":"100%"},
                  onChange: handleExamChange,
                  disabled: loading.value
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(examList.value, (exam) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: exam.id,
                        value: exam.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(exam.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "disabled"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            span: 24,
            md: 16
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: resetFilters
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode("重置筛选", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_row, {
        gutter: [16, 16],
        style: {"margin-top":"20px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 24 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "label" }, "所属班级：", -1)),
                  _createVNode(_component_a_select, {
                    value: selectedClassId.value,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((selectedClassId).value = $event)),
                    placeholder: "选择班级",
                    style: {"flex":"1"},
                    disabled: loading.value,
                    onChange: fetchStudentListAndExams
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classList.value, (cls) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: cls.id,
                          value: cls.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(cls.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "disabled"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_row, {
        gutter: [16, 16],
        style: {"margin-top":"20px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 24 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[8] || (_cache[8] = _createElementVNode("span", { class: "label" }, "学生1：", -1)),
                  _createVNode(_component_a_select, {
                    value: selectedStudent1.value,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((selectedStudent1).value = $event)),
                    placeholder: "请输入学生姓名或学号搜索",
                    style: {"flex":"1"},
                    disabled: loading.value || !selectedClassId.value,
                    "show-search": "",
                    "filter-option": false,
                    onSearch: handleStudent1Search,
                    onChange: handleStudent1Change
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredStudentList1.value, (student) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: student.id,
                          value: student.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(student.name) + " (" + _toDisplayString(maskStudentId(student.uid)) + ") ", 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "disabled"])
                ]),
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "versus" }, "VS", -1)),
                _createElementVNode("div", _hoisted_9, [
                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "label" }, "学生2：", -1)),
                  _createVNode(_component_a_select, {
                    value: selectedStudent2.value,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((selectedStudent2).value = $event)),
                    placeholder: "请输入学生姓名或学号搜索",
                    style: {"flex":"1"},
                    disabled: loading.value || !selectedClassId.value,
                    "show-search": "",
                    "filter-option": false,
                    onSearch: handleStudent2Search,
                    onChange: handleStudent2Change
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredStudentList2.value, (student) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: student.id,
                          value: student.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(student.name) + " (" + _toDisplayString(maskStudentId(student.uid)) + ") ", 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: fetchComparisonData,
                    disabled: isCompareBtnDisabled.value,
                    class: "compare-button"
                  }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode(" 开始对比 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_11, [
        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "label" }, "显示方式：", -1)),
        _createVNode(_component_a_radio_group, {
          value: displayMode.value,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((displayMode).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio, { value: "table" }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createTextVNode("表格", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]),
    (loading.value)
      ? (_openBlock(), _createBlock(_component_a_spin, {
          key: 0,
          tip: "加载中...",
          class: "loading-spin"
        }))
      : _createCommentVNode("", true),
    (!loading.value && hasSearched.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_a_row, { gutter: 16 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  span: 24,
                  md: 8
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, [
                      _cache[14] || (_cache[14] = _createElementVNode("h3", null, "总分", -1)),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("span", _hoisted_16, _toDisplayString(getStudentName(selectedStudent1.value)), 1),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(formatScore(comparisonData.value.total_score?.current || 0)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("span", _hoisted_19, _toDisplayString(getStudentName(selectedStudent2.value)), 1),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(formatScore(comparisonData.value.total_score?.compare || 0)), 1)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["difference", getScoreDiffClass(totalScoreDiff.value)])
                      }, " 差值: " + _toDisplayString(formatScore(Math.abs(totalScoreDiff.value))), 3)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  span: 24,
                  md: 8
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_21, [
                      _cache[15] || (_cache[15] = _createElementVNode("h3", null, "班级排名", -1)),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("span", _hoisted_23, _toDisplayString(getStudentName(selectedStudent1.value)), 1),
                        _createElementVNode("span", _hoisted_24, _toDisplayString(comparisonData.value.class_rank?.current || 0), 1)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("span", _hoisted_26, _toDisplayString(getStudentName(selectedStudent2.value)), 1),
                        _createElementVNode("span", _hoisted_27, _toDisplayString(comparisonData.value.class_rank?.compare || 0), 1)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["difference", getRankDiffClass(rankDiff.value)])
                      }, " 差值: " + _toDisplayString(Math.abs(rankDiff.value)), 3)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  span: 24,
                  md: 8
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_28, [
                      _cache[16] || (_cache[16] = _createElementVNode("h3", null, "年级排名", -1)),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("span", _hoisted_30, _toDisplayString(getStudentName(selectedStudent1.value)), 1),
                        _createElementVNode("span", _hoisted_31, _toDisplayString(comparisonData.value.grade_rank?.current || 0), 1)
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("span", _hoisted_33, _toDisplayString(getStudentName(selectedStudent2.value)), 1),
                        _createElementVNode("span", _hoisted_34, _toDisplayString(comparisonData.value.grade_rank?.compare || 0), 1)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["difference", getRankDiffClass(gradeRankDiff.value)])
                      }, " 差值: " + _toDisplayString(Math.abs(gradeRankDiff.value)), 3)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subjectList.value, (subject) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "subject-modules",
              key: subject.enKey
            }, [
              _createVNode(_component_a_row, {
                gutter: 16,
                style: {"margin-top":"16px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    md: 8
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("h3", null, _toDisplayString(subject.name), 1),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("span", _hoisted_37, _toDisplayString(getStudentName(selectedStudent1.value)), 1),
                          _createElementVNode("span", _hoisted_38, _toDisplayString(formatScore(subject.s1Score)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("span", _hoisted_40, _toDisplayString(getStudentName(selectedStudent2.value)), 1),
                          _createElementVNode("span", _hoisted_41, _toDisplayString(formatScore(subject.s2Score)), 1)
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["difference", getScoreDiffClass(subject.scoreDiff)])
                        }, " 分数差值: " + _toDisplayString(formatScore(Math.abs(subject.scoreDiff))), 3)
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_a_col, {
                    span: 24,
                    md: 8
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("h3", null, _toDisplayString(subject.name) + "班级排名", 1),
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("span", _hoisted_44, _toDisplayString(getStudentName(selectedStudent1.value)), 1),
                          _createElementVNode("span", _hoisted_45, _toDisplayString(subject.s1ClassRank), 1)
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("span", _hoisted_47, _toDisplayString(getStudentName(selectedStudent2.value)), 1),
                          _createElementVNode("span", _hoisted_48, _toDisplayString(subject.s2ClassRank), 1)
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["difference", getRankDiffClass(subject.classRankDiff)])
                        }, " 班排差值: " + _toDisplayString(typeof subject.classRankDiff === 'number' ? Math.abs(subject.classRankDiff) : subject.classRankDiff), 3)
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_a_col, {
                    span: 24,
                    md: 8
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("h3", null, _toDisplayString(subject.name) + "年级排名", 1),
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("span", _hoisted_51, _toDisplayString(getStudentName(selectedStudent1.value)), 1),
                          _createElementVNode("span", _hoisted_52, _toDisplayString(subject.s1GradeRank), 1)
                        ]),
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("span", _hoisted_54, _toDisplayString(getStudentName(selectedStudent2.value)), 1),
                          _createElementVNode("span", _hoisted_55, _toDisplayString(subject.s2GradeRank), 1)
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["difference", getRankDiffClass(subject.gradeRankDiff)])
                        }, " 年排差值: " + _toDisplayString(typeof subject.gradeRankDiff === 'number' ? Math.abs(subject.gradeRankDiff) : subject.gradeRankDiff), 3)
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!loading.value && hasSearched.value && !comparisonData.value.valid)
      ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
          _createVNode(_component_a_empty, { description: "未找到对比数据，请选择其他学生或考试" })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})